module.exports = __webpack_public_path__ + "img/IMG_3945_Mockup.ffb900f4.jpg";